import React from 'react'
import {
  AddRounded,
  GpsFixedRounded,
  RemoveRounded,
} from '@mui/icons-material'
import {
  ControlsStack, ControlGroup, ControlButton, RecenterImage,
} from './styles'

// Reemplaza los botones de Google: centrar la moto y acercar o alejar.
// El botón de centrar muestra el mismo ícono de Trakku que marca la moto en el mapa;
// sin imagen (moto sin GPS) se centra en el usuario.
function MapControls({
  onZoomIn,
  onZoomOut,
  onRecenter,
  recenterLabel,
  recenterImage,
  onLocateUser,
  show3DToggle,
  is3D,
  onToggle3D,
}) {
  return (
    <ControlsStack>
      {onLocateUser ? (
        <ControlGroup>
          <ControlButton aria-label="Centrar mi ubicación" title="Centrar mi ubicación" onClick={onLocateUser}>
            <GpsFixedRounded />
          </ControlButton>
        </ControlGroup>
      ) : null}
      {onRecenter ? (
        <ControlGroup>
          <ControlButton aria-label={recenterLabel} title={recenterLabel} onClick={onRecenter}>
            {recenterImage ? <RecenterImage src={recenterImage} alt="" /> : <GpsFixedRounded />}
          </ControlButton>
        </ControlGroup>
      ) : null}
      {show3DToggle ? (
        <ControlGroup>
          <ControlButton
            active={is3D}
            aria-pressed={is3D}
            aria-label="Edificios en 3D"
            title={is3D ? 'Ver el mapa plano (2D)' : 'Ver edificios en 3D'}
            onClick={onToggle3D}
          >
            3D
          </ControlButton>
        </ControlGroup>
      ) : null}
      <ControlGroup>
        <ControlButton aria-label="Acercar" title="Acercar" onClick={onZoomIn}>
          <AddRounded />
        </ControlButton>
        <ControlButton aria-label="Alejar" title="Alejar" onClick={onZoomOut}>
          <RemoveRounded />
        </ControlButton>
      </ControlGroup>
    </ControlsStack>
  )
}

export { MapControls }
